"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var Collapse_1 = __importDefault(require("../Collapse"));

var withStyles_1 = require("../styles/withStyles");

var createStyles_1 = require("../styles/createStyles");

var styles = function styles(_ref) {
  var breakpoints = _ref.breakpoints,
      spacing = _ref.spacing;
  return createStyles_1.createStyles({
    root: {
      padding: spacing(2)
    }
  });
};

var PanelContent = React.forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      classes = _a.classes,
      _a$enableCollapse = _a.enableCollapse,
      enableCollapse = _a$enableCollapse === void 0 ? false : _a$enableCollapse,
      panelExpanded = _a.panelExpanded,
      handlePanelToggle = _a.handlePanelToggle,
      style = _a.style,
      other = __rest(_a, ["children", "classes", "enableCollapse", "panelExpanded", "handlePanelToggle", "style"]);

  var className = clsx_1.default(classes.root, props.className);
  var contentBody = React.createElement("div", {
    className: className,
    style: style
  }, children);

  if (enableCollapse) {
    return React.createElement(Collapse_1.default, Object.assign({
      in: panelExpanded,
      unmountOnExit: true,
      timeout: "auto"
    }, other), contentBody);
  }

  return contentBody;
});
exports.default = withStyles_1.withStyles(styles, {
  name: 'UnifiPanelContent'
})(PanelContent);